// import * as types from "./actionTypes";
import { Query, Cloud } from "../infra";
import cookie from "react-cookies";

let globalStore = null;
let dispatch = null;
export function setStore(store) {
  globalStore = store;
  dispatch = store.dispatch;
}

export function getStore() {
  return globalStore;
}

export function init() {}

export function setUser(user) {
  cookie.save("user", user, {
    path: "/"
  });
  globalStore.dispatch({
    type: "user",
    usuario: user,
    loadUser: false
  });
}

export function changePage(page) {
  var pageGerenciador = false;
  var pageNovidades = false;
  var pageReceitas = false;
  var pageManual = false;
  var pageGarantia = false;
  var pageInit = false;
  var pageHome = false;

  if (page == "Gerenciador") {
    pageGerenciador = true;
  } else if (page == "Novidades") {
    pageNovidades = true;
  } else if (page == "Receitas") {
    pageReceitas = true;
  } else if (page == "Manual") {
    pageManual = true;
  } else if (page == "Garantia") {
    pageGarantia = true;
  } else if (page == "Init") {
    pageInit = true;
  } else if (page == "Home") {
    pageInit = true;
  }

  globalStore.dispatch({
    type: "teste",
    value: false,
    pageGerenciador: pageGerenciador,
    pageNovidades: pageNovidades,
    pageReceitas: pageReceitas,
    pageManual: pageManual,
    pageGarantia: pageGarantia,
    pageHome: pageHome,
    pageInit: pageInit
  });
}

export function loadUser() {
  var state = globalStore.getState();
  var user = cookie.load("user");
  if (user && user.objectId) {
    updateUser(user.objectId, res => {
      if (res && res.objectId) {
        setUser(res);
      } else if (!state.usuario && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    });
  } else if (!state.usuario && window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
}
export function getUser() {
  var state = globalStore.getState();
  return state.usuario;
}
export function updateUser(id, callback) {
  var query = new Query("user_local");
  query.whereEqualTo("_id", id);
  query.first(data => {
    if (data.objectId) {
      callback(data);
    } else {
      callback(false);
    }
  });
}

export function logar(login, senha, callback) {
  Cloud.get("login", { login: login, senha: senha }, (ret, error) => {
    if (error) {
      if (callback) callback(null, error);
    } else if (callback) {
      if (ret.data) {
        callback(ret.data);
      } else {
        callback(ret);
      }
    }
  });
  /*
  Cloud.get("login", { login: login, senha: senha }, ret => {
    let data = ret == undefined ? undefined : ret.data;
    console.log(ret);
    if (data && data.objectId && data.ativo == true) {
      if (callback) callback();
    } else {
      if (ret != undefined && ret.msg != undefined) {
        //fazer um alert decente
        alert(ret.msg);
      }
    }
  });*/
}

export function usuariosBuscaTodos(callback) {
  Cloud.get("usuarios", {}, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function usuariosUpdate(id, obj, callback) {
  Cloud.put("usuarios/" + id, obj, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function novidadeBuscaTodos(where, callback) {
  if (where == undefined) {
    where = {};
  }
  Cloud.get("novidades", where, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function novidadePorID(id, callback) {
  Cloud.get("novidades/" + id, {}, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function novidadeInsert(obj, callback) {
  Cloud.post("novidades", obj, ret => {
    if (callback) {
      callback(ret.data);
    }
  });
}

export function novidadeUpdate(obj, id, callback) {
  Cloud.put("novidades/" + id, obj, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function novidadeDelete(id, callback) {
  Cloud.delete("novidades/" + id, {}, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function receitaBuscaTodos(where, callback) {
  if (where == undefined) {
    where = {};
  }
  Cloud.get("receitas", where, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function receitaPorID(id, callback) {
  Cloud.get("receitas/" + id, {}, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function receitaInsert(obj, callback) {
  Cloud.post("receitas", obj, ret => {
    if (callback) {
      callback(ret.data);
    }
  });
}

export function receitaUpdate(obj, id, callback) {
  Cloud.put("receitas/" + id, obj, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function receitaDelete(id, callback) {
  Cloud.delete("receitas/" + id, {}, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function manualBuscaTodos(where, callback) {
  if (where == undefined) {
    where = {};
  }
  Cloud.get("manuais", where, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function manualPorID(id, callback) {
  Cloud.get("manuais/" + id, {}, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function manualInsert(obj, callback) {
  Cloud.post("manuais", obj, ret => {
    if (callback) {
      callback(ret.data);
    }
  });
}

export function manualUpdate(obj, id, callback) {
  Cloud.put("manuais/" + id, obj, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function manualDelete(id, callback) {
  Cloud.delete("manuais/" + id, {}, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function garantiaBuscaTodos(where, callback) {
  if (where == undefined) {
    where = {};
  }
  Cloud.get("termos", where, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function garantiaPorID(id, callback) {
  Cloud.get("termos/" + id, {}, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function garantiaInsert(obj, callback) {
  Cloud.post("termos", obj, ret => {
    if (callback) {
      callback(ret.data);
    }
  });
}

export function garantiaUpdate(obj, id, callback) {
  Cloud.put("termos/" + id, obj, ret => {
    if (callback) {
      callback(ret);
    }
  });
}

export function garantiaDelete(id, callback) {
  Cloud.delete("termos/" + id, {}, ret => {
    if (callback) {
      callback(ret);
    }
  });
}



// WEBPACK FOOTER //
// ./src/redux/actions.js